import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { forwardRef, useEffect, useCallback } from 'react';
import { Box } from '@material-ui/core';
import { UtilsLib } from '@payface-frontends-libs/utils';
const { track } = UtilsLib.Generics;
export const Page = forwardRef(({ children, title = '', ...other }, ref) => {
    const { pathname } = useLocation();
    const sendPageViewEvent = useCallback(() => {
        track.pageview({
            page_path: pathname,
        });
    }, []);
    useEffect(() => {
        sendPageViewEvent();
    }, [sendPageViewEvent]);
    return (_jsxs(Box, Object.assign({ ref: ref }, other, { children: [_jsx(Helmet, { children: _jsx("title", { children: title }, void 0) }, void 0), children] }), void 0));
});
//# sourceMappingURL=Page.js.map